import { DateTime } from "luxon";

export type DashboardScheduleDateRange = {
  from: string;
  to: string;
};

export function getDashboardScheduleDateRange(now: DateTime = DateTime.now()): DashboardScheduleDateRange {
  const from = now.toISODate() ?? now.toFormat("yyyy-MM-dd");
  const to =
    now.plus({ months: 1 }).endOf("month").toISODate() ?? now.plus({ months: 1 }).endOf("month").toFormat("yyyy-MM-dd");

  return { from, to };
}
